<div id="crop-health-note-filter-modal">
  <div class="body">
    <div class="year-filter-container">
      <div class="filter-item">
        <p class="filter-item-label">{{ 'doktar_app.common.year' | translate }}</p>
        <div class="year-filter-btns">
          @for (year of yearOptions; track year) {
            <span class="year-filter-btn" [class.selected]="selectedYear == year" (click)="selectedYear = year">{{
              year
            }}</span>
          }
        </div>
      </div>
      <div class="filter-item">
        <p class="filter-item-label">
          {{ 'doktar_app.services.crop_monitoring.note_filter.labels' | translate }}
        </p>
        <div class="row">
          <div class="col-6">
            <p-checkbox (onChange)="onSelectAllLabels($event)" [binary]="true" [ngModel]="allLabelsSelected" />
            <span class="checkbox-label">{{ 'doktar_app.common.all' | translate }}</span>
          </div>
          @for (noteTag of noteTags; track noteTag.key) {
            <div class="col-6 py-1">
              <p-checkbox
                [binary]="true"
                [ngModel]="isLabelSelected(noteTag.value)"
                (onChange)="onSelectLabel($event, noteTag.value)" />
              <span class="checkbox-label">{{ noteTag.value }}</span>
            </div>
          }
        </div>
        <div class="no-label-divider"></div>
        <div class="row no-label-row">
          <div class="col-6">
            <p-checkbox (onChange)="onSelectNoLabel($event)" [binary]="true" [ngModel]="noLabel" />
            <span class="checkbox-label">{{
              'doktar_app.services.crop_monitoring.note_filter.no_label' | translate
            }}</span>
          </div>
        </div>
      </div>
      <div class="filter-item">
        <p class="filter-item-label">
          {{ 'doktar_app.services.crop_monitoring.note_filter.photos' | translate }}
        </p>
        <div class="row">
          <div class="col-6">
            <p-checkbox (onChange)="onSelectPhotoAttached($event)" [binary]="true" [ngModel]="photosAttached" />
            <span class="checkbox-label">{{
              'doktar_app.services.crop_monitoring.note_filter.photo_attached' | translate
            }}</span>
          </div>
          <div class="col-6">
            <p-checkbox (onChange)="onSelectPhotoNotAttached($event)" [binary]="true" [ngModel]="photosNotAttached" />
            <span class="checkbox-label">{{
              'doktar_app.services.crop_monitoring.note_filter.photo_not_attached' | translate
            }}</span>
          </div>
        </div>
      </div>

      <div class="filter-item">
        <p class="filter-item-label">
          {{ 'doktar_app.common.description' | translate }}
        </p>
        <div class="row">
          <div class="col-6">
            <p-checkbox (onChange)="onSelectDescriptionAdded($event)" [binary]="true" [ngModel]="descriptionAdded" />
            <span class="checkbox-label">{{
              'doktar_app.services.crop_monitoring.note_filter.description_add' | translate
            }}</span>
          </div>
          <div class="col-6">
            <p-checkbox
              (onChange)="onSelectDescriptionNotAdded($event)"
              [binary]="true"
              [ngModel]="descriptionNotAdded" />
            <span class="checkbox-label">{{
              'doktar_app.services.crop_monitoring.note_filter.description_not_add' | translate
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer row">
    <div class="col-6">
      <dk-button [label]="'doktar_app.common.apply' | translate" severity="primary" (onClick)="apply()" />
    </div>
    <div class="col-6">
      <dk-button
        [label]="'doktar_app.common.reset_to_default' | translate"
        severity="secondary"
        (onClick)="resetFilters()" />
    </div>
  </div>
</div>
